import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
export const LoginSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Email,
    id: "email",
    label: "이메일",
    placeholder: "이메일을 입력하세요.",
    behavior: {
      required: true,
    },
  },
  {
    type: FormFieldType.Password,
    id: "password",
    label: "비밀번호",
    placeholder: "비밀번호를 입력하세요.",
    behavior: {
      required: true,
    },
  },
];

export const AdminLoginSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Email,
    id: "email",
    label: "이메일",
    placeholder: "이메일을 입력하세요.",
    description: "어드민 계정을 통해 로그인할 이메일을 입력해주세요.",
    behavior: {
      required: true,
    },
  },
];
